import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

import { OracleEvents } from './oracleEvents.types'

class OracleAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.ORACLE)
  }

  public logSendMessage(): void {
    this.logEvent({
      event: OracleEvents.SEND_MESSAGE,
    })
  }

  public logMessageReceived(responseContent: string, responseTimeMs: number): void {
    this.logEvent({
      event: OracleEvents.MESSAGE_RECEIVED,
      response_time_ms: responseTimeMs,
      response_content_length: responseContent.length,
    })
  }

  public logFirstMessageEvent(): void {
    this.logEvent({
      event: OracleEvents.FIRST_MESSAGE_EVENT,
    })
  }

  public logBootcampLinkReceived(link: string): void {
    this.logEvent({
      event: OracleEvents.BOOTCAMP_LINK_RECEIVED,
      label: link,
    })
  }

  public logEncyclopediaLinkReceived(link: string): void {
    this.logEvent({
      event: OracleEvents.ENCYCLOPEDIA_LINK_RECEIVED,
      label: link,
    })
  }

  public logCurriculumLinkReceived(link: string): void {
    this.logEvent({
      event: OracleEvents.CURRICULUM_LINK_RECEIVED,
      label: link,
    })
  }

  public logStandaloneLinkReceived(link: string): void {
    this.logEvent({
      event: OracleEvents.STANDALONE_LINK_RECEIVED,
      label: link,
    })
  }

  public logRateLimitHit(conversationMessages: number): void {
    this.logEvent({
      event: OracleEvents.RATE_LIMIT_HIT,
      conversation_messages: conversationMessages,
    })
  }

  public logNetworkError(): void {
    this.logEvent({
      event: OracleEvents.NETWORK_ERROR,
    })
  }

  public logUnauthorized(): void {
    this.logEvent({
      event: OracleEvents.UNAUTHORIZED,
    })
  }

  public logDragWindowFinished(): void {
    this.logEvent({
      event: OracleEvents.DRAG_WINDOW_FINISHED,
    })
  }

  public logResizeWindowFinished(): void {
    this.logEvent({
      event: OracleEvents.RESIZE_WINDOW_FINISHED,
    })
  }
}

export default new OracleAnalytics()
